function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { Html } from "@custom/schema";
import clsx from "clsx";
import { selectAll } from "hast-util-select";
import React from "react";
var unorderedItems = function() {
    return function(tree) {
        selectAll("ul > li", tree).forEach(function(node) {
            node.properties.unordered = true;
        });
    };
};
export function BlockText(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx([
            "mx-auto max-w-full prose xl:text-lg break-words",
            "prose-a:text-gray-600",
            "prose-blockquote:border-yellow-500 prose-blockquote:not-italic prose-blockquote:lg:text-xl prose-blockquote:font-heading",
            "prose-em:text-gray-600",
            "prose-strong:text-gray-600",
            "prose-h2:md:mt-14",
            "prose-ul:mb-8",
            "marker:text-gray-600 marker:font-bold"
        ])
    }, /*#__PURE__*/ React.createElement(Html, {
        plugins: [
            unorderedItems
        ],
        components: {
            li: function(_param) {
                var unordered = _param.unordered, children = _param.children, className = _param.className, _$props = _object_without_properties(_param, [
                    "unordered",
                    "children",
                    "className"
                ]);
                return /*#__PURE__*/ React.createElement("li", _object_spread_props(_object_spread({}, _$props), {
                    className: clsx(className, {
                        '!pl-4 mb-2.5 relative before:content-[""] before:block before:h-1.5 before:w-1.5 before:bg-blue-500 before:absolute before:top-2.5 before:left-0': unordered
                    })
                }), children);
            }
        },
        markup: props.markup
    }));
}
